var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoadingArticle)?_c('skeleton'):_c('div',{domProps:{"innerHTML":_vm._s(_vm.articleHtml)}})}
var staticRenderFns = []

export { render, staticRenderFns }